// @ts-check
if (!window.AndDaughter) {
  window.AndDaughter = {};
}

window.AndDaughter.productButtonScroll = function () {
  /**
   * @param Record<string, string>
   * Classes used as CSS styling hooks
   */
  const classes = {
    scrollDowned: "is-scrolled-past-button",
    isTitleinView: "is-title-in-view",
  };

  /**
   * @param {HTMLElement}
   * an element just before the add to cart button element
   * this element is static on the page and has a non-brekaing space in it so its position can be calculated with getBoundingClientRect()
   */
  const placeholder = document.querySelector("[data-button-scroll-warning]");

  /**
   * @param {HTMLElement}
   * A container for the product title and its price
   */
  const title = document.querySelector("[data-product-title]");

  /**
   * Add a CSS class that makes the button stick in place
   *
   * @returns {void}
   */
  const unstick = () => {
    document.documentElement.classList.add(classes.scrollDowned);
  };

  /**
   * if the observed element is in view, add a class to the html tag
   * which will turn off position:fixed
   * @param {IntersectionObserverEntry[]} entries,
   * @param {IntersectionObserver} observer
   *
   * @returns {void}
   */
  function toggleStickyButton(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        unstick();
      } else {
        if (entry.boundingClientRect.top > 0) {
          document.documentElement.classList.remove(classes.scrollDowned);
        }
      }
    });
  }

  /**
   * if the observed element is in view, add a class to the html tag
   * which will turn off position:fixed
   * @param {IntersectionObserverEntry[]} entries,
   * @param {IntersectionObserver} observer
   *
   * @returns {void}
   */
  function toggleStickyTitle(entries, observer) {
    entries.forEach((entry) => {
      console.log(entry);

      if (entry.isIntersecting) {
        document.documentElement.classList.add(classes.isTitleinView);
      } else {
        // if (entry.boundingClientRect.top > 0) {
        document.documentElement.classList.remove(classes.isTitleinView);
        // }
      }
    });
  }

  /**
   * Set up an IntersectionObsever instance and track whether the placeholder element
   * is in the viewport
   *
   * @returns {void}
   */
  function observeButtonPlaceholder() {
    if (!placeholder) {
      return;
    }
    let options = {
      root: null,
      rootMargin: "0px",
      threshold: 1,
    };

    let observer = new IntersectionObserver(toggleStickyButton, options);
    observer.observe(placeholder);
  }

  /**
   * Set up an IntersectionObsever instance and track whether the placeholder element
   * is in the viewport
   *
   * @returns {void}
   */
  function observeTitle() {
    if (!title) {
      return;
    }
    let options = {
      root: null,
      rootMargin: "0px",
      threshold: 1,
    };

    let observer = new IntersectionObserver(toggleStickyTitle, options);
    observer.observe(title);
  }

  /**
   * Scripts/tasks that run when object is first created
   *
   * @returns {void}
   */
  const init = () => {
    if ("IntersectionObserver" in window) {
      observeButtonPlaceholder();
      observeTitle();
    }
  };

  return {
    init,
    unstick,
  };
};

window.AndDaughter.productButtonScroll().init();
